import React from 'react'
import { IRoute } from '@interfaces/route.interface'
import { routersPath } from './routes-path'
import { EUserRoles } from '@enums/roles'
const BannersPage = React.lazy(() => import('@pages/BannersPage/BannersPage'))
const TariffsPage = React.lazy(() => import('@pages/TariffsPage/TariffsPage'))
const PhoneOperatorPage = React.lazy(() => import('@pages/PhoneOperatorPage/PhoneOperatorPage'))
const BillingPage = React.lazy(() => import('../pages/BillingPage/BillingPage'))
const TelephonyPage = React.lazy(() => import('../pages/TelephonyPage/TelephonyPage'))
const ReportsPage = React.lazy(() => import('../pages/Reports/ReportsPage/ReportsPage'))
const ExpensesPage = React.lazy(() => import('../pages/Reports/ExpensesPage/ExpensesPage'))
const IncomesPage = React.lazy(() => import('../pages/Reports/IncomesPage/IncomesPage'))
const SalaryPage = React.lazy(() => import('../pages/Reports/SalaryPage/SalaryPage'))
const ReportPage = React.lazy(() => import('../pages/ReportPage/ReportPage'))
const UsersPage = React.lazy(() => import('../pages/UsersPage/UsersPage'))
const CrmsPage = React.lazy(() => import('../pages/CrmsPage/CrmsPage'))
const UserPage = React.lazy(() => import('../pages/UserPage/UserPage'))
const CrmPage = React.lazy(() => import('../pages/CrmPage/CrmPage'))
const MainPage = React.lazy(() => import('../pages/MainPage/MainPage'))

export const privateRoutes: IRoute[] = [
  {
    roles: [EUserRoles.BOSS, EUserRoles.SUPER_ADMIN],
    path: routersPath.MAIN_PAGE,
    component: <MainPage />,
    title: 'Статистика',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.USERS,
    component: <UsersPage />,
    title: 'Пользователи',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.CRMS,
    component: <CrmsPage />,
    title: 'Crms',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.SUPER_ADMIN],
    path: routersPath.USER,
    component: <UserPage />,
    title: 'User',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.SUPER_ADMIN],
    path: routersPath.CRM,
    component: <CrmPage />,
    title: 'Crm',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.REPORTS,
    component: <ReportsPage />,
    title: 'Reports',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.REPORT,
    component: <ReportPage />,
    title: 'Report',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.EXPENSES,
    component: <ExpensesPage />,
    title: 'Expenses',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.INCOMES,
    component: <IncomesPage />,
    title: 'Incomes',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.SALARY,
    component: <SalaryPage />,
    title: 'Salary',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.BILLING,
    component: <BillingPage />,
    title: 'Billing',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN, EUserRoles.ACCOUNTANT, EUserRoles.PHONE_OPERATOR],
    path: routersPath.TELEPHONY,
    component: <TelephonyPage />,
    title: 'Telephony',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN, EUserRoles.ACCOUNTANT, EUserRoles.PHONE_OPERATOR],
    path: routersPath.PHONE_OPERATOR,
    component: <PhoneOperatorPage />,
    title: 'Telephony operator',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.TARIFFS,
    component: <TariffsPage />,
    title: 'Telephony tariffs',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.BANNERS,
    component: <BannersPage />,
    title: 'Banners',
  },
]
